import { useEffect, useState } from "react"
import { Link } from "react-router-dom-7"

import { Toast } from "~/shared/ui/kit"
import { useUserInfo } from "~/domain/user-session"
import { getUserSessions } from "~/domain/user-session/api/sessions"
import { IconButton } from "~/shared/ui"

export function CheckActiveUserSessions() {

	const [hasActiveSessions, setHasActiveSessions] = useState(false)
	const userInfo = useUserInfo()

	useEffect(() => {
		if (userInfo) {
			getUserSessions().then(sessions => {
				const ipSet = new Set()

				for (const session of sessions) {
					ipSet.add(session.ip)
				}

				if (ipSet.size > 1) setHasActiveSessions(true)
			})
		}
	}, [userInfo])

	return <Toast type="darkInfo" show={hasActiveSessions}>
		<div>
			У Вас есть активные сессии! Возможно Вы забыли выйти из системы на другом устройстве. <br />
			В <Link onClick={() => setHasActiveSessions(false)} to="/main/profile/user-sessions"
					style={{ color: "white" }}>профиле</Link> можно посмотреть и закрыть активные сессии.
		</div>
		<div>
			<IconButton onClick={() => setHasActiveSessions(false)} icon="close" transparent borderless
						colorStyle="light" />
		</div>
	</Toast>
}